import { ChevronUp, Languages } from 'lucide-react';
import { useTranslation } from '@/shared/web/i18n/LanguageProvider';
import { isLanguage, languages } from '@/shared/web/i18n/catalog';
import { Button } from '@/web/components/ui/button';
import {
  DropdownMenu, DropdownMenuContent, DropdownMenuGroup, DropdownMenuLabel,
  DropdownMenuRadioGroup, DropdownMenuRadioItem, DropdownMenuSeparator, DropdownMenuTrigger,
} from '@/web/components/ui/dropdown-menu';

export function LanguageSelector() {
  const { language, setLanguage, t } = useTranslation();
  return (
    <DropdownMenu>
      <DropdownMenuTrigger asChild>
        <Button variant="ghost" className="w-full justify-start" aria-label={t('Change language')}>
          <Languages data-icon="inline-start" />
          <span className="flex-1 text-left" lang={language}>{languages.find(({ code }) => code === language)!.name}</span>
          <ChevronUp data-icon="inline-end" />
        </Button>
      </DropdownMenuTrigger>
      <DropdownMenuContent side="top" align="start" className="w-52">
        <DropdownMenuGroup>
          <DropdownMenuLabel>{t('Language')}</DropdownMenuLabel>
          <DropdownMenuSeparator />
          <DropdownMenuRadioGroup value={language} onValueChange={(value) => { if (isLanguage(value)) setLanguage(value); }}>
            {languages.map(({ code, name }) => (
              <DropdownMenuRadioItem key={code} value={code} lang={code}>{name}</DropdownMenuRadioItem>
            ))}
          </DropdownMenuRadioGroup>
        </DropdownMenuGroup>
      </DropdownMenuContent>
    </DropdownMenu>
  );
}
